import React, { useState } from 'react';
import ArrowRight from '../../../assets/images/account-page/arrowRight.svg';
import ArrowDown from '../../../assets/icons/arrow-down-icon.svg';
import ArrowUp from '../../../assets/icons/arrow-up-icon.svg';
import PlaneSubscription from '../../../assets/icons/plane-subscription-icon.svg';
import AlertTriangleIcon from '../../../assets/icons/triangle-alert-icon.svg';
import { useIntl } from 'react-intl';
import messages from './messages';
import config from '../../../config';
import moment from 'moment';
import { isMobile } from 'react-device-detect';

const locale = {
  en: 'en-gb',
  nl: 'nl',
  es: 'es',
  pl: 'pl',
  be: 'fr',
  fr: 'fr',
  it: 'it',
  de: 'de',
  da: 'da',
};

/* tslint:disable no-var-requires */
require(`moment/locale/${locale[config?.locale] || 'en-gb'}`);
interface FlightSubscriptionInterface {
  flight_date: Date;
  flight_code: string;
  departureAirport: {
    iata: string;
  };
  arrivalAirport: {
    iata: string;
  };
  airline: {
    name: string;
  };
}

const FlightComponent = (props: any) => {
  const [open, setOpen] = useState(true);
  const [fightsToAdd, setFlightsToAdd] = useState([]);
  const {
    data,
    setFlightsToSave,
    addFlight = false,
    errorReason = '',
    subscriptionBillingCycle = {},
  } = props;

  const { formatMessage } = useIntl();
  const flights =
    data?.[0]?.flights || data?.[0]?.allSubscriptionFlights || data;
  const subscription_start_date =
    subscriptionBillingCycle?.starts_at ||
    data?.[0]?.subscriptionBillingCycle?.starts_at;
  const subscription_end_date =
    subscriptionBillingCycle?.ends_at ||
    data?.[0]?.subscriptionBillingCycle?.ends_at;

  const handleOpen = () => {
    setOpen(!open);
  };

  const handleFlight = (flightId: any) => {
    if (!fightsToAdd.length) {
      setFlightsToAdd([flightId]);
      if (setFlightsToSave) {
        setFlightsToSave([flightId]);
      }
    } else {
      setFlightsToAdd((prevItems: any) => {
        if (prevItems.includes(flightId)) {
          return prevItems.filter((item: string) => item !== flightId);
        } else {
          return [...prevItems, flightId];
        }
      });
      if (setFlightsToSave) {
        setFlightsToSave((prevItems: any) => {
          if (prevItems.includes(flightId)) {
            return prevItems.filter((item: string) => item !== flightId);
          } else {
            return [...prevItems, flightId];
          }
        });
      }
    }
  };

  return (
    <>
      {flights?.map((item: FlightSubscriptionInterface, index: number) => (
        <div
          key={item?.id}
          className="flight-subscription-container"
          style={index > 0 ? { marginTop: '20px' } : {}}
        >
          <span className="flight-date" style={{ opacity: '0.5' }}>
            {moment(item?.flight_date).format('DD MMMM YYYY')}
          </span>
          <div className="flight-box-container overflow-hidden">
            <div className="box-header flex">
              <div className="box-header-info flex">
                {addFlight && (
                  <div style={{ marginRight: '15px' }}>
                    <input
                      type="checkbox"
                      disabled={
                        errorReason ===
                          'flights_not_at_least_48_hours_in_future' ||
                        item?.status === 'Denied'
                      }
                      onClick={() =>
                        handleFlight(item?.id || item?.flight_date)
                      }
                    />
                  </div>
                )}
                <div className="airports">
                  <span className="iata-info">
                    {item?.departureAirport?.iata ||
                      item?.departure_airport?.iata}
                  </span>
                  <img src={ArrowRight} alt="" width={15} height={15} />
                  <span className="iata-info">
                    {item?.arrivalAirport?.iata || item?.arrival_airport?.iata}
                  </span>
                </div>
                <div className="vertical-line" />
                <span>{item?.airline?.name}</span>
                <div className="vertical-line" />
                <span>{item?.flight_code}</span>
              </div>
              <div className="box-header-arrow">
                <img
                  src={open ? ArrowUp : ArrowDown}
                  alt=""
                  style={{ cursor: 'pointer' }}
                  onClick={handleOpen}
                />
              </div>
            </div>
            {open ? (
              <div className="box-content flex">
                <div className="content-container flex flex-col md:flex-row">
                  <div className="flight-info flex">
                    <span className="iata-info">
                      (
                      {item?.departureAirport?.iata ||
                        item?.departure_airport?.iata}
                      )
                    </span>
                    <hr style={{ marginLeft: '15px' }} />
                    <img
                      src={PlaneSubscription}
                      alt=""
                      width={24}
                      height={24}
                    />
                    <hr style={{ marginRight: '15px' }} />
                    <span className="iata-info">
                      (
                      {item?.arrivalAirport?.iata ||
                        item?.arrival_airport?.iata}
                      )
                    </span>
                  </div>
                  <div>
                    <span className="flight-nr" style={{ opacity: '50%' }}>
                      {formatMessage(messages.subscriptionFlightNr)}{' '}
                      {item?.flight_code}
                    </span>
                    <span
                      className="flight-date"
                      style={{ marginLeft: '12px', opacity: '50%' }}
                    >
                      {formatMessage(messages.subscriptionFlightDate)}{' '}
                      {moment(item?.flight_date).format('L')}
                    </span>
                  </div>
                </div>
                {item?.status_reason ===
                  'flights_not_at_least_48_hours_in_future' ||
                item?.status_reason ===
                  'flight_not_at_least_48_hours_in_future' ? (
                  <div className="flex" style={warningMsgStyles}>
                    <img
                      src={AlertTriangleIcon}
                      alt=""
                      width={24}
                      height={24}
                    />
                    <span style={textErrorStyles}>
                      {formatMessage(messages.hours48FlightsError, {
                        subscription_start_date: moment(
                          subscription_start_date
                        ).format('DD MMMM YYYY'),
                        subscription_end_date: moment(
                          subscription_end_date
                        ).format('DD MMMM YYYY'),
                      })}
                    </span>
                  </div>
                ) : (
                  item?.status_reason ===
                    'flight_already_added_to_other_trip' && (
                    <div className="flex items-center" style={warningMsgStyles}>
                      <img
                        src={AlertTriangleIcon}
                        alt=""
                        width={24}
                        height={24}
                      />
                      <span style={textErrorStyles}>
                        {formatMessage(messages.repeatedFlightError)}
                      </span>
                    </div>
                  )
                )}
              </div>
            ) : null}
          </div>
        </div>
      ))}
    </>
  );
};

export default FlightComponent;

const warningMsgStyles = {
  gap: '12px',
  padding: '6px',
  borderRadius: '6px',
  backgroundColor: '#FCF6DD',
  marginTop: '12px',
  marginBottom: '12px',
  height: isMobile ? 'auto' : '63px',
};

const textErrorStyles = {
  fontSize: '14px',
  fontWeight: '400',
  lineHeight: '16.94px',
  letterSpacing: '-0.02em',
  textAlign: 'left',
};
